import { render } from "./CheckoutModal.vue?vue&type=template&id=070952f4&scoped=true&ts=true"
import script from "./CheckoutModal.vue?vue&type=script&lang=ts"
export * from "./CheckoutModal.vue?vue&type=script&lang=ts"

import "./CheckoutModal.vue?vue&type=style&index=0&id=070952f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070952f4"]])

export default __exports__